import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/components/forms/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/components/nav/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/components/nav/MenuLanding.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/components/ui/ImageComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/osborne/OSBORNE_FRONT_STAGE_3/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
